// extracted by mini-css-extract-plugin
module.exports = {"element":"e3afc254ff--element--hhgQA","element--inline":"e3afc254ff--element--inline--PoE3w"};